import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogActions, Typography, Grid, Box } from '@mui/material';
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import { Button } from 'components';
import FileUpload from 'components/FileUpload';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { toast } from 'react-toastify';

const EditOrganizationModal = ({ open, onClose, onSave, loading, org }) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [formData, setFormData] = useState({
    description: org?.description || '',
    logo: null
  });

  React.useEffect(() => {
    setFormData({
      description: org?.description || '',
      logo: null
    });
    setUploadedFiles([]); 
  }, [org]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (files) => {  
    if (files && files.length > 0) {
      const file = files[0];
      const maxSize = 1 * 1024 * 1024; 
      
      if (file.size > maxSize) {
        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        toast.error(`Image exceeds 1 MB. Your file is ${fileSizeMB} MB.`);
        setUploadedFiles([]);
        setFormData((prev) => ({
          ...prev,
          logo: null
        }));
        return;
      }
    }
    
    setUploadedFiles(files);
    setFormData((prev) => ({
      ...prev,
      logo: files && files.length > 0 ? files[0] : null
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting:', { formData });
    if (formData.logo) {
      console.log('Logo File object:', formData.logo);
    }

    onSave(e, {...formData,file: formData.logo });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '8px',
          width: { xs: '100%', md: '700px' },
          maxWidth: { xs: '100%', md: '700px' }
        }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex' }}>
          <Box
            sx={{
              border: '2px solid #a83c3c', 
              borderRadius: '12%',
              width: 36,
              height: 36,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mr: 1
            }}
          >
            <PriorityHighOutlinedIcon 
              sx={{ color: '#a83c3c', fontSize: 22 }} 
            />
          </Box>
          <Typography variant="h6">Edit Profile</Typography>
        </Box>
      </DialogTitle>

      <ValidatorForm onSubmit={handleSubmit} instantValidate={false}>
        <Grid container spacing={2} sx={{ px: 3, pb: 2 }}>
          
     
          <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <FileUpload
              label="Set the logo of your organization"
              value={uploadedFiles}
              onChange={handleFileChange}
              multiple={false}
              acceptedFileTypes={["image/*"]}
              helperText="Format: png, jpg, & Max file size: 1 MB"
              disabled={loading}
            />
          </Grid>

          
          <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TextValidator
              label="Write a description about the organization"
              name="description"
              multiline
              rows={4}
              value={formData.description}
              onChange={handleInputChange}
              validators={['required']}
              errorMessages={['This field is required']}
              required={true}
              disabled={loading}
              sx={{ width: '100%' }}
            />
          </Grid>
        </Grid>

        <DialogActions sx={{ gap: 2, p: 2 }}>
          <Button 
            onClick={onClose} 
            variant="outlined" color="error" 
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            type="submit" 
            process={loading}
          >
            {loading ? 'Saving...' : 'Save'}
          </Button>
        </DialogActions>
      </ValidatorForm>
    </Dialog>
  );
};

export default EditOrganizationModal;